export enum PostReportReasonEnum {
  LinkIsNotWorking,
  FraudulentOrPhishingLink,
  InappropriateOrExplicitContent,
  MalwareOrHarmfulSoftware,
  SpamOrUnwantedContent,
  LinkIsExpiredOrInvalid,
  CopyrightInfringement,
  HateSpeechOrDiscriminatoryContent,
  OtherReasons,
}
export const PostReportReasonList = [
  {
    value: PostReportReasonEnum.LinkIsNotWorking,
    label: 'Link Is Not Working',
    description: 'e.g., the link is broken or leads to a 404 error',
    iconPath: 'report/link-not-working.svg',
  },
  {
    value: PostReportReasonEnum.FraudulentOrPhishingLink,
    label: 'Fraudulent Or Phishing Link',
    description:
      'The link leads to a site aiming to steal user data or carry out scams',
    iconPath: 'report/fraudulent-or-phishing-link.svg',
  },
  {
    value: PostReportReasonEnum.InappropriateOrExplicitContent,
    label: 'Inappropriate Or Explicit Content',
    description: 'e.g., links containing sexual or violent material',
    iconPath: 'report/inappropriate-or-explicit-content.svg',
  },
  {
    value: PostReportReasonEnum.MalwareOrHarmfulSoftware,
    label: 'Malware Or Harmful Software',
    description:
      'The link redirects to a site that could harm the user’s device',
    iconPath: 'report/malware-or-harmful-software.svg',
  },
  {
    value: PostReportReasonEnum.SpamOrUnwantedContent,
    label: 'Spam Or Unwanted Content',
    description: 'e.g., links leading to spam or excessive advertising',
    iconPath: 'report/spam-or-unwanted-content.svg',
  },
  {
    value: PostReportReasonEnum.LinkIsExpiredOrInvalid,
    label: 'Link Is Expired Or Invalid',
    description: 'The link was valid but is no longer functional',
    iconPath: 'report/link-is-expired-or-invalid.svg',
  },
  {
    value: PostReportReasonEnum.CopyrightInfringement,
    label: 'Copyright Infringement',
    description: 'e.g., The link points to pirated or unauthorized material',
    iconPath: 'report/copyright-infringement.svg',
  },
  {
    value: PostReportReasonEnum.HateSpeechOrDiscriminatoryContent,
    label: 'Hate Speech Or Discriminatory Content',
    description: 'Links promoting racism, hate, or any kind of discrimination',
    iconPath: 'report/hate-speech-or-discriminatory-content.svg',
  },
  {
    value: PostReportReasonEnum.OtherReasons,
    label: 'Other reasons',
    description: 'Enter custom reason',
    iconPath: 'report/other-reasons.svg',
  },
];
